export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8946.c73e17a4.jpg";